import React from "react";
import SidebarMenu from "./SidebarMenu";

const DashboardSidebarMenu = ({ title, menus }) => {
  if (!menus) {
    menus = [];
  }
  return (
    <div className="w-72 bg-white h-full border-r p-4 shadow-lg m-8">
      {/* Sidebar Title */}
      <div className="text-xl font-bold  text-onWhite">
        <i className="fas fa-shopping-cart mr-2"></i>
        {title}
      </div>

      {/* Dynamic Menu Items */}
      <div className="space-y-4">
        {menus.map((menu, index) => (
          <SidebarMenu key={index} menu={menu} />
        ))}
      </div>
    </div>
  );
};

export default DashboardSidebarMenu;
